import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useCallback } from 'react';
import styles from './FullscreenImageSlider.module.scss';
import ResponsiveSlider from '../ResponsiveSlider';
const FullscreenImageSlider = ({ images, isOpen, initialSlide = 0, onClose, zoom = true, loop = false, spaceBetween = 0, ariaLabel = 'Image gallery', }) => {
    const [swiper, setSwiper] = React.useState(null);
    // Update swiper when it mounts
    useEffect(() => {
        if (swiper && isOpen) {
            // Small delay to ensure DOM is ready
            const timer = setTimeout(() => {
                swiper.update();
            }, 50);
            return () => clearTimeout(timer);
        }
    }, [swiper, isOpen]);
    // Handle escape key
    useEffect(() => {
        if (!isOpen)
            return;
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);
    const handleBackdropClick = useCallback((e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    }, [onClose]);
    if (!isOpen)
        return null;
    return (_jsxs("div", Object.assign({ className: styles['fullscreen-slider'], onClick: handleBackdropClick }, { children: [_jsx("button", Object.assign({ className: styles['fullscreen-slider-close'], onClick: onClose, "aria-label": 'Close fullscreen', type: 'button' }, { children: _jsxs("svg", Object.assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, { children: [_jsx("line", { x1: '18', y1: '6', x2: '6', y2: '18' }), _jsx("line", { x1: '6', y1: '6', x2: '18', y2: '18' })] })) })), _jsx("div", Object.assign({ className: styles['fullscreen-slider-content'] }, { children: _jsx(ResponsiveSlider, { items: images, onSwiper: setSwiper, className: styles['fullscreen-slider-wrapper'], showNavigation: true, showPagination: true, autoplay: false, loop: loop, spaceBetween: spaceBetween, slidesPerView: 1, zoom: zoom, initialSlide: initialSlide, ariaLabel: ariaLabel, renderItem: (image) => (_jsx("div", Object.assign({ className: styles['fullscreen-slider-image-container'] }, { children: _jsx("div", Object.assign({ className: zoom ? 'swiper-zoom-container' : '' }, { children: _jsx("img", { src: image.src, alt: image.alt }) })) }))) }) }))] })));
};
export default FullscreenImageSlider;
